import React, { useState } from "react";
import { useSite } from "../context/SiteContext";
import { X } from "lucide-react";

export function Banner() {
  const { settings } = useSite();
  const [closed, setClosed] = useState(false);
  if (!settings.banner_active || !settings.banner_text || closed) return null;

  const content = (
    <span className="text-sm font-medium text-white">{settings.banner_text}</span>
  );

  return (
    <div
      data-testid="top-banner"
      className="relative flex items-center justify-center gap-3 px-4 py-2.5"
      style={{ background: "linear-gradient(90deg, #E50914 0%, #7a0208 100%)" }}
    >
      {settings.banner_link ? (
        <a data-testid="banner-link" href={settings.banner_link} target="_blank" rel="noopener noreferrer" className="hover:underline">
          {content}
        </a>
      ) : (
        content
      )}
      <button
        data-testid="banner-close-button"
        onClick={() => setClosed(true)}
        className="absolute right-3 text-white/80 hover:text-white"
      >
        <X size={18} />
      </button>
    </div>
  );
}
